import * as React from 'react';
import System from 'src/helper/system';

const SurveyForm = (props) => {
  const { SetStatus, data } = props;

  const { translation:t } = System;
  const renderQuestion = (question, placeholder, withClass = true) => (
    <div className='survey-content' style={withClass ? {} : { borderBottom: 0, paddingBottom: 0 }}>
      <div className='font-arial font-15 mb-2'>
        <strong>{question.forM_QUESTION_TX}</strong>
      </div>
      <div className="form-group mb-0">
        <label htmlFor="response">{t('response')}:</label>
        <input
          type="text"
          disabled={true}
          name="response"
          placeholder={placeholder}
          className="form-control form-control-sm"
          defaultValue={question.forM_ANSWER_TX}
        />
      </div>
    </div>
  );

  return (
    <>
      <div className="avnet-modal modal-730 surveyresponse">
        <div className="avnet-modal-inner">
          {/* Modal Header */}
          <button type="button" className="close py-3" data-dismiss="modal"
            onClick={() => {
              SetStatus(false)
            }}>×</button>
          <div className="modal-header justify-content-center mt-0">
            <h3 className="pcn-modal-heading pl-5">{t('surveyResponse')}</h3>
          </div>

          {/* Modal body */}
          <div className="modal-body">
            <div className="clearfix" />
            {data?.data?.map(item => {
              if (item.forM_QUESTION_ID) {
                return (
                  <div key={item.forM_QUESTION_ID}>
                    {renderQuestion(item, item.forM_ANSWER_TX, item.forM_QUESTION_ID === 170 ? false : true)}
                  </div>
                );
              }
              
              return null;
            })}
          </div>

          {/* Modal footer */}
          <div className="modal-footer text-center">
            <div className="modal-footer-actions">
              <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                onClick={() => {
                  SetStatus(false)
                }}>
                {t('close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SurveyForm;
